import { render, staticRenderFns } from "./InviteSent.vue?vue&type=template&id=3438d413&lang=pug&"
import script from "./InviteSent.vue?vue&type=script&lang=js&"
export * from "./InviteSent.vue?vue&type=script&lang=js&"
import style0 from "./InviteSent.vue?vue&type=style&index=0&id=3438d413&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports